import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface DataRefreshContextType {
  version: number;
  triggerRefresh: () => void;
}

const DataRefreshContext = createContext<DataRefreshContextType>({
  version: 0,
  triggerRefresh: () => {},
});

export function useDataRefresh() {
  return useContext(DataRefreshContext);
}

export function DataRefreshProvider({ children }: { children: ReactNode }) {
  const [version, setVersion] = useState(0);
  const triggerRefresh = useCallback(() => setVersion(v => v + 1), []);

  return (
    <DataRefreshContext.Provider value={{ version, triggerRefresh }}>
      {children}
    </DataRefreshContext.Provider>
  );
}